import EditIcon from "@mui/icons-material/Edit";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import React from "react";
import { ColumnContainer } from "utils/columnsStyle";
import { useDispatch } from "react-redux";

import { FACILITIES_CONFIG } from "./config";
import { editFacility } from "redux/actions/buildings/facilities/facilitiesActions";

const style = {
  color: '#004F9F',
  fontSize: 20,
  marginRight: 10,
  cursor: 'pointer'
}

export const columns = [
  {
    Header: () => <span>{FACILITIES_CONFIG.registrationDate.label}</span>,
    accessor: FACILITIES_CONFIG.registrationDate.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.registrationDate.key]
        ? row[FACILITIES_CONFIG.registrationDate.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.facilityName.label}</span>,
    accessor: FACILITIES_CONFIG.facilityName.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.facilityName.key]
        ? row[FACILITIES_CONFIG.facilityName.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.contactName.label}</span>,
    accessor: FACILITIES_CONFIG.contactName.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.contactName.key]
        ? row[FACILITIES_CONFIG.contactName.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.contactNumber.label}</span>,
    accessor: FACILITIES_CONFIG.contactNumber.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.contactNumber.key]
        ? row[FACILITIES_CONFIG.contactNumber.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.fullAddress.label}</span>,
    accessor: FACILITIES_CONFIG.fullAddress.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.fullAddress.key]
        ? row[FACILITIES_CONFIG.fullAddress.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.regimen.label}</span>,
    accessor: FACILITIES_CONFIG.regimen.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.regimen.key]
        ? row[FACILITIES_CONFIG.regimen.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.route.label}</span>,
    accessor: FACILITIES_CONFIG.route.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.route.key]
        ? row[FACILITIES_CONFIG.route.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.station.label}</span>,
    accessor: FACILITIES_CONFIG.station.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.station.key]
        ? row[FACILITIES_CONFIG.station.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },

  {
    Header: () => <span>{FACILITIES_CONFIG.paymentCycle.label}</span>,
    accessor: FACILITIES_CONFIG.paymentCycle.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.paymentCycle.key]
        ? row[FACILITIES_CONFIG.paymentCycle.key]
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.discount.label}</span>,
    accessor: FACILITIES_CONFIG.discount.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.discount.key]
        ? row[FACILITIES_CONFIG.discount.key]
            .toString()
            .includes(filter.value)
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.adminCost.label}</span>,
    accessor: FACILITIES_CONFIG.adminCost.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.adminCost.key]
        ? row[FACILITIES_CONFIG.adminCost.key]
            .toString()
            .includes(filter.value)
        : "",
  },
  {
    Header: () => <span>{FACILITIES_CONFIG.reconnectionCost.label}</span>,
    accessor: FACILITIES_CONFIG.reconnectionCost.key,
    filterable: true,
    filterMethod: (filter, row) =>
      row[FACILITIES_CONFIG.reconnectionCost.key]
        ? row[FACILITIES_CONFIG.reconnectionCost.key]
            .toString()
            .includes(filter.value)
        : "",
  },
  {
    Header: () => <span>Acciones</span>,
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const openEdit = () => {
        original.modal();
        dispatch(editFacility(original.id));
      };

      const openDiscount = () => {
        original.discountModal()
        dispatch(editFacility(original.id));
      }

      return (
        <ColumnContainer>
          <AttachMoneyIcon style={style} onClick={openDiscount} />
          <EditIcon style={style} onClick={openEdit} />
        </ColumnContainer>
      );
    },
  },
];
